import React, { memo, useCallback, useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { CloseIcon, DropDownArrow, FilterSettings } from '@yme/assets/icons';
import { MiniButton } from '@yme/atoms/mini-button';
import { MobileDropdownSlider } from '@yme/atoms/mobile-dropdown-slider';
import { formatFilterTitle, getActiveAmount, getSubmitMobileLabel, } from '@yme/molecules/filter-dropdown/helpers';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { buildKey } from '@yme/utils/common';
import { OF_AMOUNT_TEMPLATE, SHOWING_AMOUNT_TEMPLATE } from '@yme/utils/constants';
import { FilterMenuItem } from './FilterMenuItem';
import { FilterContextMobile } from './filterContextMobile';
import { CloseIconStyled, FilterMobileMenuStyled, MobileFilterButtonStyled, ModalWindowFooterStyled, ResetFilterStyled, TitleStyled, } from './styled';
// TODO (A.N.) change CheckboxesDropdownMobile on FilterDropdown approach
function FilterDropdownMobileElement({ filtersList, labels, onSelect, handleResetFilters, paginationData, articlesLength, isRightItem = false, hasCloseIcon = true, selectedOptions, isShowingPanelNeeded = false, isRightToLeft, commonLabels, buttonWidth = '100%', defaultPageSearch, }) {
    const [isExpanded, setIsExpanded] = useState(false);
    const [isResetPushed, setIsResetPushed] = useState(false);
    const [disableFirstEffect, setDisableFirstEffect] = useState(false);
    const [currentFilter, setCurrentFilter] = useState('');
    const [dynamicContextFields, setDynamicContextFields] = useState([]);
    const history = useHistory();
    const filterLabel = formatFilterTitle(labels.filters_filters_label, dynamicContextFields.length);
    const { showedItems } = paginationData;
    const addDynamicContextField = useCallback((field) => {
        setDynamicContextFields((prevArray) => {
            const updatedFields = [...prevArray];
            const repeatedFieldIndex = prevArray.findIndex((existingField) => existingField.name === field.name);
            if (repeatedFieldIndex === -1) {
                if (field.value.length > 0) {
                    updatedFields.push(field);
                }
            }
            else if (field.value.length > 0) {
                updatedFields[repeatedFieldIndex] = {
                    ...prevArray[repeatedFieldIndex],
                    ...field,
                };
            }
            else {
                updatedFields[repeatedFieldIndex] = {
                    ...prevArray[repeatedFieldIndex],
                    value: [],
                };
            }
            return updatedFields;
        });
    }, []);
    const contextValue = useMemo(() => ({
        currentFilter,
        setCurrentFilter,
        dynamicContextFields,
        addDynamicContextField,
        selectedOptions,
    }), [addDynamicContextField, currentFilter, dynamicContextFields, selectedOptions]);
    const onOpenDropdown = () => {
        setIsExpanded(!isExpanded);
    };
    const onClose = () => {
        if (isExpanded) {
            setIsExpanded(false);
        }
        else {
            setIsExpanded(true);
        }
    };
    const onFilterFieldClick = (filterName) => {
        if (filterName) {
            setCurrentFilter(filterName);
        }
    };
    const onShowResults = () => {
        onClose();
    };
    const onResetFilters = () => {
        if (handleResetFilters) {
            handleResetFilters();
        }
        else {
            setIsResetPushed(true);
            setDynamicContextFields([]);
            history.push(defaultPageSearch);
        }
    };
    const menuFooter = (React.createElement(ModalWindowFooterStyled, { cancelButtonLabel: commonLabels.common_cancel_button, onHide: onClose, onSubmit: onShowResults, submitButtonLabel: getSubmitMobileLabel(!dynamicContextFields.length, labels.filters_showResults_label, showedItems), isSubmitButtonDisabled: !dynamicContextFields.length }));
    const list = filtersList.map((item, index) => (React.createElement(FilterMenuItem, { key: buildKey(item.label, index), item: item, label: getActiveAmount(dynamicContextFields, item.label), onClickHandler: onFilterFieldClick })));
    const dropdownTitle = (React.createElement(TitleStyled, null,
        React.createElement("span", null, filterLabel),
        React.createElement(ResetFilterStyled, { onClick: onResetFilters, type: "button" }, labels.filters_resetFilters_label)));
    useEffect(() => {
        if (!disableFirstEffect) {
            onSelect(dynamicContextFields);
        }
        else {
            setDisableFirstEffect(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dynamicContextFields]);
    useEffect(() => {
        if (!isResetPushed) {
            setDisableFirstEffect(true);
            setIsResetPushed(false);
            setDynamicContextFields(selectedOptions);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedOptions]);
    const counterLabel = (labels?.filters_showingOf_label || '')
        .replace(SHOWING_AMOUNT_TEMPLATE, `1-${articlesLength}`)
        .replace(OF_AMOUNT_TEMPLATE, `${showedItems}`);
    return (React.createElement(FilterContextMobile.Provider, { value: contextValue },
        React.createElement(MobileFilterButtonStyled, { onClick: onOpenDropdown, iconType: FilterSettings, isFirstIcon: true, isRightIcon: isRightItem, buttonWidth: buttonWidth },
            hasCloseIcon && (React.createElement(CloseIconStyled, { isRightToLeft: isRightToLeft, onClick: onClose, iconRotate: 180, type: isExpanded ? CloseIcon : DropDownArrow })),
            filterLabel),
        isShowingPanelNeeded && (React.createElement(FlexWrapper, { justifyContent: "space-between", mt: "16px" },
            React.createElement("span", null, counterLabel),
            React.createElement(MiniButton, { onClick: onResetFilters, isPaddingsReset: true, isUnderlined: true }, labels.filters_clearFilters_label))),
        Boolean(list.length) && (React.createElement(MobileDropdownSlider, { footerComponent: menuFooter, title: dynamicContextFields.length ? dropdownTitle : filterLabel, isActive: isExpanded, handleActiveMobileSlider: onClose, isResetContentPadding: true },
            React.createElement(FilterMobileMenuStyled, null, list)))));
}
export const FilterDropdownMobile = memo(FilterDropdownMobileElement);
